export default __webpack_public_path__ + "static/media/customer04.95d344de.jpg";